module.exports = __webpack_public_path__ + "static/media/condeixa-4.44357a41.jpg";